import { useTranslation } from "features/translations";
import React, { useMemo } from "react";
import { Container, Heading3, PageLink, Paragraph } from "shared/components";

import { Item } from "../Item";
import styles from "./GridView.module.scss";

export const GridView = ({ title, articles }) => {
  const { t } = useTranslation();

  const limitedItem = useMemo(() => articles.slice(0, 3), [articles]);

  return (
    <>
      <Container className={styles.inner}>
        <div className={styles.header}>
          <Heading3 className={styles.title}>{title}</Heading3>
        </div>
        {limitedItem.map((item) => (
          <Item key={item.id} className={styles.item} {...item} />
        ))}
        <PageLink slug={"news"} className={styles.link}>
          <Paragraph className={styles.text} color="dark" uppercase>
            {t("showAllNews")}
          </Paragraph>
        </PageLink>
      </Container>
    </>
  );
};

export default GridView;
